import { EuiSpacer } from '@elastic/eui';
import ASTable from 'components/Web_User_Interface/720p_Series/Alarm/Alarmserver/asTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  ASTable,
  BreadCrumbs,
  SEOHelmet,
  React
};